"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Age["default"];
  }
});
var _Age = _interopRequireDefault(require("./Age"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }